'use client';

export { default } from './CssBaseline';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/CssBaseline/index.js
// module id = 912
// module chunks = 25